import Button from './Button';
import React from 'react';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const UnsavedHeaderWrapper = styled('div')`
  height: inherit;
  display: flex;
  align-items: center;

  .unsaved-header-text {
    font-size: 16px;
  }

  .cancel {
    margin-right: 20px;
  }

  @media (max-width: 767px) {
    display: flex;
    padding: 10px 16px;
    margin-right: -10px;
    font-size: 13px;
    background: #fff;
    position: relative;

    .unsaved-header-text {
      font-size: 13px;
    }

    .buttons-wrapper {
      display: flex;

      .btn {
        padding: 5px 10px;
      }

      .btn-light {
        margin-right: 10px;
      }
    }
  }
`;

const UnsavedHeader = (props) => {
  const { handleSubmit, loading, disabled = false, hideCancelButton = false } = props;

  const { t } = useAutoTranslation();

  return (
    <UnsavedHeaderWrapper>
      <div className="unsaved-header-text">{t('Изменения не сохранены')}!</div>
      <div className="buttons-wrapper" style={{ marginLeft: 'auto' }}>
        {!loading && !hideCancelButton ? (
          <button className="btn btn btn-light cancel" onClick={() => document.location.reload()}>
            {t('Отмена')}
          </button>
        ) : null}
        <Button
          text={t('Сохранить')}
          onClick={handleSubmit}
          disabled={loading || disabled}
          loading={loading}
        />
      </div>
    </UnsavedHeaderWrapper>
  );
};

export default UnsavedHeader;
